import { ApiInfo, apiInfoFunc } from '@/network/apiInfo'

type SetupIntent = {}
type SetupIntentResponse = {
    clientSecret: string
}

const apiInfoPostSetupIntent: ApiInfo<
    SetupIntentResponse,
    undefined,
    SetupIntent
> = {
    method: 'POST',
    url: () => '/web_ec_v2/setup_intent',
    response: {} as SetupIntentResponse,
    query: undefined,
    requestBody: {} as SetupIntent,
}

export const usePostSetupIntent = apiInfoFunc.toUseRequest(
    apiInfoPostSetupIntent
)
